/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
/**
 * brandPresets — curated colour palettes offered as one-click starting points
 * on the Brand Settings admin page. Each preset covers the three core roles
 * (primary, primaryAlt for the gradient counterpart, accent) plus a matching
 * favicon-friendly recommendation for the tagline tone.
 *
 * NOTE: hex values are hand-picked for WCAG AA contrast on both black and
 * white backgrounds. Do not swap without testing contrast.
 */
import { Stethoscope, Pill, Sparkles, Baby } from 'lucide-react';

export const BRAND_PRESETS = [
  {
    id: 'medico',
    label: 'Medico',
    description: 'Professionale, sobrio. Ideale per medicina generale e specialistica.',
    icon: Stethoscope,
    primaryColor: '#0F766E',       // Teal 700
    primaryColorAlt: '#059669',    // Emerald 600
    accentColor: '#A7F3D0',        // Emerald 200
    taglineSuggestion: 'La community dei professionisti sanitari',
  },
  {
    id: 'farmacia',
    label: 'Farmacia',
    description: 'Verde brillante e caldo. Comunica fiducia, natura, benessere.',
    icon: Pill,
    primaryColor: '#15803D',       // Green 700
    primaryColorAlt: '#65A30D',    // Lime 600
    accentColor: '#FDE68A',        // Amber 200
    taglineSuggestion: 'La tua farmacia di fiducia, ogni giorno',
  },
  {
    id: 'dentistico',
    label: 'Studio Dentistico',
    description: 'Cyan pulito e fresco. Trasmette igiene e precisione clinica.',
    icon: Sparkles,
    primaryColor: '#0369A1',       // Sky 700
    primaryColorAlt: '#0891B2',    // Cyan 600
    accentColor: '#BAE6FD',        // Sky 200
    taglineSuggestion: 'Sorridi con serenità',
  },
  {
    id: 'pediatria',
    label: 'Pediatria',
    description: 'Corallo caldo e amichevole. Perfetto per bambini e famiglie.',
    icon: Baby,
    primaryColor: '#DB2777',       // Pink 600
    primaryColorAlt: '#F97316',    // Orange 500
    accentColor: '#FED7AA',        // Orange 200
    taglineSuggestion: 'Cura pediatrica con il sorriso',
  },
];

export default BRAND_PRESETS;
